export default "__VITE_ASSET__CiT8gKj$__"